import React, { useState, useRef } from "react";
import { FormattedMessage } from "react-intl";
import { AutoComplete } from "antd";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import FilterDeadlinesChips from "./filterDeadlinesChips";

const DocumentNumberFilter = ({filterCounter, setFilterCounter, selectedDocumentNumbers, setSelectedDocumentNumbers}) => {

  const [documentNumberOptions, setDocumentNumberOptions] = useState([]);
  const [documentNumberValue, setDocumentNumberValue] = useState("");
  const reconcilableDeadlines = useSelector(state => state.reconciliation.operations.reconcilableDeadlines);

  const refDocumentNumber = useRef();

  useEffect(() => {
    let documentsNumbers = [];

    const documentsNumberRaw = reconcilableDeadlines?.filteredDeadlines?.map(d => {
      return d.description?.data?.docNumber;
    });
    const uniqDocumentsAmounts = [...new Set(documentsNumberRaw)];

    for (const deadline of uniqDocumentsAmounts) {
      if (deadline !== undefined) {
        documentsNumbers.push({
          value: deadline
        });
      }
    }

    setDocumentNumberOptions(documentsNumbers);
  }, [reconcilableDeadlines]);

  const onChangeDocumentNumber = (e, isToAddInChips) => {
    setDocumentNumberValue(e);

    if (e && isToAddInChips) {
      if (selectedDocumentNumbers.length === 0) {
        setFilterCounter(filterCounter + 1);
      }
      if (!selectedDocumentNumbers.includes(e)) {
        const selectedDocCopy = [...selectedDocumentNumbers];
        selectedDocCopy.push(e);
        setDocumentNumberValue("");
        setSelectedDocumentNumbers(selectedDocCopy);
      }
    }
  };

  const removeDocumentNumbers = index => {
    const selectedDocCopy = [...selectedDocumentNumbers];
    selectedDocCopy.splice(index, 1);
    setSelectedDocumentNumbers(selectedDocCopy);
  };

  const renderDocumentNumbersChips = () => {
    return (
      <FilterDeadlinesChips
        selectedItems={selectedDocumentNumbers}
        onRemoveSelectedItems={index => removeDocumentNumbers(index)}
        key={"docNumber"}
      />
    );
  };

  return (
    <div className="document-number-filter">
      <h4 className="document-filter-title"><FormattedMessage id="generic.documentNumber"/></h4>
      <AutoComplete
        ref={refDocumentNumber}
        allowClear={true}
        popoverPlacement={"bottom"}
        getPopupContainer={trigger => trigger.parentNode}
        options={documentNumberOptions}
        style={{ width: "100%" }}
        initialValue={documentNumberValue}
        value={documentNumberValue}
        filterOption={(inputValue, option) => {
          if (inputValue === "") return true;
          return option.value.toUpperCase().indexOf(inputValue.toUpperCase())>-1;
        }
        }
        placeholder={""}
        notFoundContent={"Nessun risultato"}
        onClear={()=> {
          onChangeDocumentNumber("", false);
          refDocumentNumber.current.focus();
        }}
        onSearch={el => {
          onChangeDocumentNumber(el, false);
        }}
        onSelect={ el => {
          onChangeDocumentNumber(el, true);
          refDocumentNumber.current.blur();
        }}
      />
      {renderDocumentNumbersChips()}
    </div>
  );
};

export default DocumentNumberFilter;
